import { query, request } from '@/utils/request';
// 获取合同列表
export const getContractList = data => {
  return query('/zlb/api/expense/contract/list', { method: 'POST', data });
  // return request('/zlb/api/expense/contract/v3/list', { method: 'POST', data });
};

export const getContractListV3 = data => {
  return request('/zlb/api/expense/contract/v3/list', { method: 'POST', data });
};

// 获取合同详情-义乌合同重构新接口
export const getContractDetail = params => {
  return query('/zlb/api/expense/contract/detail', { method: 'get', params });
};

export const getContractDetailV3 = params => {
  return query('/zlb/api/expense/contract/v3/detail', { method: 'get', params });
};

// 获取合同详情-运营机构查看
export const getContractDetailByOperate = params => {
  return query('/zlb/api/expense/contract/detail-operate', { method: 'get', params });
};

// 获取合同详情-政采云合同预览
export const getZcyContractDetail = params => {
  return query('/zlb/api/expense/contract/detail/zcy', { method: 'get', params });
};

// 合同日志信息
export const getContractLog = data => {
  return query('/zlb/api/expense/contract/log/list', { method: 'POST', data });
};

// 单位信息查询
export const getCompanyInfo = async params => {
  return query('/zlb/api/expense/apply-form/default-info', {
    params,
  });
};

// 创建/编辑合同
export const submitContract = data => {
  return query('/zlb/api/expense/contract/createOrUpdate', {
    method: 'POST',
    data,
  });
};
/**
 * 删除和作废合同
 * 备注：删除和作废时根据合同当前状态判断
 * @param contractCode 合同编号
 * @returns
 */
export const delContract = contractCode => {
  return query(`/zlb/api/expense/contract/delete/${contractCode}`, {
    method: 'DELETE',
  });
};
// 提交工作流
export const submitWorkFlow = data => {
  return request('/zlb/api/expense/workflow/submit', {
    method: 'POST',
    data,
  });
};
// 撤回合同
export const stopWorkFlow = data => {
  return request('/zlb/api/expense/workflow/stop', {
    method: 'POST',
    data,
  });
};
/**
 * 申请单详情
 * @param params
 * @returns
 */
export const getApplyDetail = params => {
  return query('/zlb/api/expense/apply-form/query', {
    method: 'GET',
    params,
  });
};
// 被驳回原因
export const getRefuseReason = params => {
  return query('/zlb/api/expense/workflow/refuseReason', {
    method: 'GET',
    params,
  });
};
// 获取政采云合同列表
export const getZcyContractList = (params?: any) => {
  const data = params || {};
  data.morph = 1;
  // 需要处理未绑定政采云的错误， 使用request
  return request('/zlb/api/expense/contract/list/zcy', { method: 'POST', data });
};

export const importContractFromZcy = data => {
  return query('/zlb/api/expense/contract/batch-import', { method: 'POST', data });
};

// 合同创建或编辑
export const createOrUpdateContract = data => {
  return query('/zlb/api/expense/contract/createOrUpdate', {
    method: 'POST',
    data,
  });
};

// 完善合同
export const perfectContract = data => {
  return query('/zlb/api/expense/contract/perfectAfterSigned', {
    method: 'POST',
    data,
  });
};
